import { render, staticRenderFns } from "./ShortTextQuestion.vue?vue&type=template&id=c7f333d8&scoped=true&"
import script from "./ShortTextQuestion.vue?vue&type=script&lang=ts&"
export * from "./ShortTextQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f333d8",
  null
  
)

export default component.exports